import { FormContainer as FormContainerUI } from "@repo/ui-parkmobile/FormContainer";
import type { FormContainer } from "@/generated/sb";
import { assetResolver, universalLinkResolver } from "@/lib/storyblok/adaptors";
import { storyblokEditable } from "@storyblok/react/rsc";
import { ContactSection } from "@/components/sections/ContactSection";

interface FormContainerProps {
  blok: FormContainer;
  sectionName?: string;
}

export default function FormContainer({ blok, sectionName }: FormContainerProps) {
  if (!blok || !blok.form) {
    return null;
  }

  const iconAsset = blok.icon ? assetResolver(blok.icon) : undefined;
  const redirectLink = blok.redirectURL ? universalLinkResolver(blok.redirectURL) : undefined;

  const contactSectionBlok = {
    component: "contactSection" as const,
    _uid: blok._uid + "_contact",
    head: [],
    form: blok.form,
    backgroundColor: "none" as const,
    topPadding: "none" as const,
    bottomPadding: "none" as const,
    inputBackgroundColor: "white" as const,
    formBackgroundColor: "gray" as const,
    embedded: true,
    sectionName,
    redirectURL: redirectLink?.href ? String(redirectLink.href) : undefined,
  };

  return (
    <FormContainerUI
      {...storyblokEditable(blok)}
      icon={
        iconAsset
          ? {
              src: iconAsset.src,
              alt: iconAsset.alt,
            }
          : undefined
      }
      title={blok.title}
      subtitle={blok.subtitle}
    >
      <ContactSection blok={contactSectionBlok} />
    </FormContainerUI>
  );
}
